import * as React from 'react';

import {
  VALID_DIMENSION_DATA,
  VALID_EDGE_STYLE_DATA,
} from '../Utils';

import { StyledDivider } from './DividerStyles';

export interface IDividerProps {
  color?: string;
  width?: VALID_DIMENSION_DATA;
  height?: VALID_DIMENSION_DATA;
  margin?: VALID_EDGE_STYLE_DATA;
  alignSelf?: string;
}

export const Divider = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & IDividerProps>(
  (props, ref) => {
  const {
    color,
    width,
    height,
    margin,
    alignSelf,
} = props;

  return (
    <StyledDivider
      ref={ref}
      colorProp={color}
      widthProp={width}
      heightProp={height}
      marginProp={margin}
      alignSelfProp={alignSelf}
    />
  );
});

export default Divider;
